import {
  KYC_BIZUM_TIMER_LOCALSTORAGE_ID,
  KYC_BIZUM_WS_TIME_PROPS,
} from '../constants/kyc-bizum.constants';

const convertSecondsToMinutesAndSeconds = (seconds: number): string => {
  const min = Math.floor(seconds / 60);
  const seg = seconds % 60;
  return `${min}:${seg.toString().padStart(2, '0')}`;
};

const getKYCBizumTimerFromStorage = (): number | null =>
  localStorage.getItem(KYC_BIZUM_TIMER_LOCALSTORAGE_ID)
    ? Number(localStorage.getItem(KYC_BIZUM_TIMER_LOCALSTORAGE_ID))
    : null;

const getInitialKYCBizumTimerFromStorage = (): number =>
  getKYCBizumTimerFromStorage() || KYC_BIZUM_WS_TIME_PROPS.timeout;

export {
  convertSecondsToMinutesAndSeconds,
  getInitialKYCBizumTimerFromStorage,
  getKYCBizumTimerFromStorage,
};
